export default __webpack_public_path__ + "static/media/empty_login.a78e8ca5.png";